// @ts-nocheck

export default {
  "l10n": {
    "date": {
      "months": {
        "full": ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
        "abbr": ["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sep.","oct.","nov.","dic."]
      },
      "days": {
        "full": ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],
        "abbr": ["do.","lu.","ma.","mi.","ju.","vi.","sá."]
      },
      "patterns": {
        "longDate": "dddd, D MMMM YYYY",
        "dateSlash": "DD/MM/YYYY",
        "dateShort": "dddd D MMMM",
        "dateShortWithDay": "Do MMMM YYYY",
        "dateMedium": "dddd D MMMM - H[.]mm",
        "dateMediumReversed" : "H[.]mm - D MMMM YYYY",
        "dateMediumSlash": "DD[/]MM[/]YYYY [alle] H[.]mm",
        "dateLarge": "D/MMM/YYYY [alle] HH[.]mm",
        "timeShort": "LT",
        "timeMedium": "DD[/]MM [•] LT",
        "timeLarge": "DD[/]MM[/]YY [•] LT"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-nS", "nS"]
      },
      "group": {
        "separator": ".",
        "length": 3,
        "abbr": ["", "k", "M", "B"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "ordinal": function(number) { return number + (number === 1 ? '°' : '°'); }
    }
  },
  "translations": {
    "messages": {
  "!action:Bet": [
    null,
    "Scommetti"
  ],
  "!action:GiftRace Start": [
    null,
    "Inizia"
  ],
  "!action:Settings": [
    null,
    "Impostazioni"
  ],
  "!action:Share": [
    null,
    "Condividi"
  ],
  "!action:deleteAndContinue": [
    null,
    "Annulla e continua"
  ],
  "!action:viewMyNonValidatedBets": [
    null,
    "Vedi le scommesse non convalidate"
  ],
  "!desc:%1$s ES RM J-30 warning": [
    null,
    "!desc:%1$s ES RM J-30 warning"
  ],
  "!desc:ArjelAdvice": [
    null,
    "Tutte le persone che volessero essere oggetto di un'interdizione dal gioco devono fare domanda al Ministero dell'Interno. Questa interdizione è valida nei casino, i club di gioco e sui siti di gioco online autorizzati dalla legge n° 2010-476 del 12 Marzo 2010, per una durata di tre anni non riducibile."
  ],
  "!desc:ArjelLink": [
    null,
    "Interdizione volontaria dal gioco"
  ],
  "!desc:ArjelTitle": [
    null,
    "Winamax est agréé par l'Autorité Nationale des Jeux"
  ],
  "!desc:BROptaWidgetWarning": [
    null,
    "I risultati delle scommesse riguardanti i tiri si basano sulle statische ufficiali degli organizzatori e non sulle statistiche visualizzate sopra."
  ],
  "!desc:BasketHowTo": [
    null,
    "Clicca sulle quote per selezionare le scommesse"
  ],
  "!desc:BetBuilderHelper": [
    null,
    "Con MyMatch puoi creare la tua scommessa selezionando diverse opzioni sulla stessa partita e ottenere così la tua quota personalizzata."
  ],
  "!desc:BetBuilderHelperBasketball": [
    null,
    "Con MyMatch puoi creare la tua scommessa selezionando diverse opzioni sulla stessa partita (squadra vincente, punti/rimbalzi/assist di un giocatore) e ottenere così la tua quota personalizzata."
  ],
  "!desc:BetBuilderHelperSoccer": [
    null,
    "Con MyMatch puoi creare la tua scommessa selezionando diverse opzioni sulla stessa partita (risultato esatto, gol segnati, marcatori ecc.) e ottenere così la tua quota personalizzata."
  ],
  "!desc:BetshareWebsite": [
    null,
    "winamax.it"
  ],
  "!desc:BzgaLegals": [
    null,
    "Eigentümer und Betreiber - Winamax SA - 136 B Rue de Grenelle, 75007 Paris, Frankreich\nGlücksspiel kann süchtig machen. Hilfe unter"
  ],
  "!desc:CashoutPendingRegulation": [
    null,
    "The Cashout amount is only paid out when all selections of the bet have been settled"
  ],
  "!desc:ClientUpdaterContent": [
    null,
    "Per aggiornare l'applicazione disinstalla la versione attuale e scarica la nuova applicazione direttamente nell’App Store."
  ],
  "!desc:ClientUpdaterContentDeprecated": [
    null,
    "Questa versione dell'applicazione non prevede gli ultimi aggiornamenti e sarà presto bloccata."
  ],
  "!desc:DEBetTaxFreeDescription": [
    null,
    "!desc:DEBetTaxFreeDescription"
  ],
  "!desc:DVTMLink": [
    null,
    "Verantwortliches Spiel"
  ],
  "!desc:DgojConfidentiality": [
    null,
    "Política de privacidad"
  ],
  "!desc:DgojLicence": [
    null,
    "\n        WINAMAX Sociedad Anónima (S.A.) cuya sede social se encuentra en 136bis Rue de Grenelle, 75007 París France.\n        Todos los derechos reservados.\n\n        WINAMAX se responsabiliza de este sitio web, al que la Dirección General de Ordenación del Juego le ha concedido las siguientes licencias: POQUER No/Ref: POQ/2018/001, APUESTAS DEPORTIVAS DE CONTRAPARTIDA No/Ref: ADC/2018/017\n\n        Está prohibida la participación de los menores de edad y los incapacitados legalmente o por resolución judicial.\n      "
  ],
  "!desc:DgojResponsibleGaming": [
    null,
    "Juego responsable"
  ],
  "!desc:DgojResponsibleGamingTextES": [
    null,
    "This is a real money gambling application. Please play responsibly and only bet what you can afford. For help and support with gambling addiction, please contact FEJAR at 900 533 025 or visit https://fejar.org/"
  ],
  "!desc:DgojTerms": [
    null,
    "Términos y condiciones"
  ],
  "!desc:DocumentTitle": [
    null,
    "Scommesse sportive | Winamax scommesse sportive | Scommesse online"
  ],
  "!desc:DocumentTitleLive": [
    null,
    "Scommesse in diretta - Scommetti sullo sport in diretta su Winamax"
  ],
  "!desc:FreebetHelper": [
    null,
    "I bonus scommesse sono offerti durante le offerte promozionali.\nIn caso di scommessa vincente, ti saranno accreditati sul tuo conto solo le vincite nette (vincite - puntata)."
  ],
  "!desc:GoalScorersHelper": [
    null,
    "Scommetti che un giocatore segnerà almeno un gol o il primo o l’ultimo gol durante la partita. Queste scommesse non prendono in considerazione eventuali tempi supplementari e calci di rigore. Gli autogol non sono contabilizzati. Se il primo gol della partita è un autogol sarà considerato come primo marcatore il giocatore che segnerà il gol successivo."
  ],
  "!desc:Minus18DE": [
    null,
    "Minderjährigen ist die Benutzung verboten"
  ],
  "!desc:MonopolyEnrollmentMessage": [
    null,
    "Completa le collezioni Monopoly grazie alle tue scommesse e vinci bonus scommesse!"
  ],
  "!desc:PanicButtonConfirmation": [
    null,
    "You have activated a 24h break across all providers. You can play again earliest on tomorrow at %1$s."
  ],
  "!desc:PanicButtonConfirmationTitle": [
    null,
    "Your account is on a break"
  ],
  "!desc:RealityCheckMessage": [
    null,
    "Non dimenticare di fare regolarmente delle pause! Puoi trovare ulteriori informazioni nella rubrica \"Protezione dei giocatori\"."
  ],
  "!desc:ResponsibleGamingTextFR": [
    null,
    "This is a real-money gambling app. Please gamble responsibly and only bet what you can afford. For gambling addiction help and support, please contact (joueurs-info-service at 09-74-75-13-13or visit http://www.joueurs-info-service.fr/."
  ],
  "!desc:SoccerDecisivePlayer": [
    null,
    "Per quanto riguarda le scommesse giocatore decisivo e assistman, le scommesse sono annullate se il giocatore su cui si è puntato non prende parte alla partita. Il risultato delle scommesse si basa sulle statistiche Opta.\nIl giocatore sarà decisivo nella partita ovvero segnerà almeno un gol o effettuerà almeno un assist (eccetto eventuali tempi supplementari e rigori)."
  ],
  "!desc:SoccerScorerDuo": [
    null,
    "Scommetti sul numero di gols segnati dai due giocatori nel corso della partita (eccetto eventuali tempi supplementari e rigori). La scommessa è rimborsata se uno dei due giocatori non prende parte alla partita."
  ],
  "!desc:SoccerScorerTrio": [
    null,
    "Scommetti sul numero di gols segnati dai tre giocatori nel corso della partita (eccetto eventuali tempi supplementari e rigori). La scommessa è rimborsata se uno dei tre giocatori non prende parte alla partita."
  ],
  "!desc:SrijLicence": [
    null,
    "WINAMAX, S.A. Todos os direitos reservados. É uma empresa registada em Portugal com o número de empresa XXXXXXXXX, com sede na XXXXXXXX, em XXXXX e é titular das licenças de jogo n° XXX e XXX emitidas pelo SRIJ – Serviço de Regulação e Inspeção de Jogos que a autoriza a desenvolver a atividade de exploração de apostas desportivas à cota e de jogos de fortuna ou azar online em Portugal."
  ],
  "!desc:activateLineUpNotifications": [
    null,
    "Vuoi ricevere una notifica non appena le formazioni delle tue partite preferite sono disponibili?\nAttiva le notifiche nelle preferenze di comunicazione"
  ],
  "!desc:userAlreadyOptedIn": [
    null,
    "Stai già partecipando a questa operazione."
  ],
  "!noun:GridsCancelled": [
    null,
    "Annullata"
  ],
  "!noun:GridsFilterCancelled": [
    null,
    "Annullate"
  ],
  "!noun:GridsFilterLost": [
    null,
    "Perdute"
  ],
  "!noun:GridsFilterRunning": [
    null,
    "In corso"
  ],
  "!noun:GridsFilterWon": [
    null,
    "Vinte"
  ],
  "!noun:GridsFinancing": [
    null,
    "In corso di finanziamento"
  ],
  "!noun:GridsFinished": [
    null,
    "Terminate"
  ],
  "!noun:GridsLost": [
    null,
    "Persa"
  ],
  "!noun:GridsNotValidated": [
    null,
    "Non convalidata"
  ],
  "!noun:GridsRunning": [
    null,
    "In corso"
  ],
  "!noun:GridsWon": [
    null,
    "Vinta"
  ],
  "!noun:MonopolyWon": [
    "!noun:MonopolyWonPlural",
    "Ottenuta:",
    "Ottenute:"
  ],
  "!noun:Rules": [
    null,
    "Regolamento"
  ],
  "!noun:Welcome": [
    null,
    "Benvenuto!"
  ],
  "!noun:Won": [
    null,
    "Vinta"
  ],
  "!plural:Finished": [
    null,
    "Terminate"
  ],
  "!plural:Won": [
    null,
    "Vinte"
  ],
  "!scorer:Next": [
    null,
    "Successiva"
  ],
  "!short:1st half - 2 or more": [
    null,
    "1° tempo - 2 o più"
  ],
  "!short:1st half - 3 or more": [
    null,
    "1° tempo - 3 o più"
  ],
  "!short:1st half - 4 or more": [
    null,
    "1° tempo - 4 o più"
  ],
  "!short:1st period - Scorer": [
    null,
    "1° tempo - Marcatore"
  ],
  "!short:2 or more": [
    null,
    "2 o più"
  ],
  "!short:2nd half - 2 or more": [
    null,
    "2° tempo - 2 o più"
  ],
  "!short:2nd half - 3 or more": [
    null,
    "2° tempo - 3 o più"
  ],
  "!short:2nd half - 4 or more": [
    null,
    "2° tempo - 4 o più"
  ],
  "!short:2nd period - Scorer": [
    null,
    "2° tempo - Marcatore"
  ],
  "!short:3 or more": [
    null,
    "3 o più"
  ],
  "!short:3rd period - Scorer": [
    null,
    "3° tempo - Marcatore"
  ],
  "!short:4 or more": [
    null,
    "4 o più"
  ],
  "!short:AdditionnalTime": [
    null,
    "EI"
  ],
  "!short:Anytime goalscorer": [
    null,
    "Marcatore"
  ],
  "!short:BothHalf": [
    null,
    "Entrambi"
  ],
  "!short:Double": [
    null,
    "Doppietta"
  ],
  "!short:Draw": [
    null,
    "X"
  ],
  "!short:First": [
    null,
    "Primo"
  ],
  "!short:FirstHalf": [
    null,
    "1°"
  ],
  "!short:HalfTime": [
    null,
    "1°T"
  ],
  "!short:Hat-trick": [
    null,
    "Tripletta"
  ],
  "!short:Last": [
    null,
    "Ultimo"
  ],
  "!short:Next": [
    null,
    "Prossimo"
  ],
  "!short:Overtime": [
    null,
    "TS"
  ],
  "!short:Overtime - 2 or more": [
    null,
    "Tempi supplementari - 2 o più"
  ],
  "!short:PenaltyShootOut": [
    null,
    "CDR"
  ],
  "!short:Points": [
    null,
    "PT"
  ],
  "!short:RegularTime": [
    null,
    "Temp. Reg."
  ],
  "!short:ScorerConversion": [
    null,
    "C"
  ],
  "!short:ScorerDrop": [
    null,
    "D"
  ],
  "!short:ScorerPenalty": [
    null,
    "P"
  ],
  "!short:SecondHalf": [
    null,
    "2°"
  ],
  "!short:Today": [
    null,
    "Oggi"
  ],
  "!short:bet": [
    "!short:bets",
    "scommessa",
    "scommesse"
  ],
  "%1$s (multiple chance)": [
    null,
    "%1$s multichance"
  ],
  "%1$s + %2$s": [
    null,
    "%1$s + %2$s"
  ],
  "%1$s Base": [
    "%1$s Bases",
    "%1$s Base",
    "%1$s Basi"
  ],
  "%1$s bet": [
    "%1$s bets",
    "%1$s scommessa",
    "%1$s scommesse"
  ],
  "%1$s bet added": [
    "%1$s bets added",
    "%1$s scommessa aggiunta",
    "%1$s scommesse aggiunte"
  ],
  "%1$s bet could not be validated": [
    "%1$s bets could not be validated",
    "%1$s scommessa non è stata convalidata",
    "%1$s scommesse non sono state convalidate"
  ],
  "%1$s bet selected": [
    "%1$s bets selected",
    "%1$s scommessa selezionata",
    "%1$s scommesse selezionate"
  ],
  "%1$s guarenteed ": [
    null,
    "%1$s garantiti"
  ],
  "%1$s or more": [
    null,
    "%1$s o più"
  ],
  "%1$s selection": [
    "%1$s selections",
    "%1$s scommessa",
    "%1$s scommesse"
  ],
  "%1$s selection could not be added": [
    "%1$s selections could not be added",
    "Non abbiamo potuto aggiungere %1$s scommessa",
    "Non abbiamo potuto aggiungere %1$s scommesse"
  ],
  "%1$s single bet": [
    "%1$s single bets",
    "%1$s scommessa singola",
    "%1$s scommesse singole"
  ],
  "%1$s's bet": [
    null,
    "Scommessa di %1$s"
  ],
  "%1$s-%2$s PSO": [
    null,
    "rigori %1$s-%2$s"
  ],
  "%1$s-%2$s a.e.t.": [
    null,
    "%1$s-%2$s d.t.s."
  ],
  "%1$s-%2$s reg. time": [
    null,
    "T. Reg. %1$s-%2$s"
  ],
  "%1$s:": [
    null,
    "%1$s:"
  ],
  "(1 to %1$s)": [
    null,
    "(da 1 a %1$s)"
  ],
  "+%1$s min": [
    null,
    "+%1$s min."
  ],
  "10th set": [
    null,
    "10° set"
  ],
  "12-grids": [
    null,
    "Schedine da 12"
  ],
  "1st": [
    null,
    "1º"
  ],
  "1st half": [
    null,
    "1° tempo"
  ],
  "1st innings": [
    null,
    "1° inning"
  ],
  "1st period": [
    null,
    "1° tempo"
  ],
  "1st quarter": [
    null,
    "1° quarto"
  ],
  "1st set": [
    null,
    "1° set"
  ],
  "2 or more": [
    null,
    "Doppietta"
  ],
  "24-hour break": [
    null,
    "Pausa di 24 ore"
  ],
  "2nd": [
    null,
    "2º"
  ],
  "2nd half": [
    null,
    "2° tempo"
  ],
  "2nd half - Multiple goalscorers": [
    null,
    "Secondo tempo – Marcatori multipli"
  ],
  "2nd innings": [
    null,
    "2° inning"
  ],
  "2nd period": [
    null,
    "2° tempo"
  ],
  "2nd quarter": [
    null,
    "2° quarto"
  ],
  "2nd set": [
    null,
    "2° set"
  ],
  "3 or more": [
    null,
    "Tripletta"
  ],
  "3rd": [
    null,
    "3º"
  ],
  "3rd innings": [
    null,
    "3° inning"
  ],
  "3rd period": [
    null,
    "3° tempo"
  ],
  "3rd quarter": [
    null,
    "3° quarto"
  ],
  "3rd set": [
    null,
    "3° set"
  ],
  "4 or more": [
    null,
    "Poker"
  ],
  "4th innings": [
    null,
    "4° inning"
  ],
  "4th quarter": [
    null,
    "4° quarto"
  ],
  "4th set": [
    null,
    "4° set"
  ],
  "5th innings": [
    null,
    "5° inning"
  ],
  "5th set": [
    null,
    "5° set"
  ],
  "6th innings": [
    null,
    "6° inning"
  ],
  "6th set": [
    null,
    "6° set"
  ],
  "7-grids": [
    null,
    "Schedine da 7"
  ],
  "7th innings": [
    null,
    "7° inning"
  ],
  "7th set": [
    null,
    "7° set"
  ],
  "8th innings": [
    null,
    "8° inning"
  ],
  "8th set": [
    null,
    "8° set"
  ],
  "9th innings": [
    null,
    "9° inning"
  ],
  "9th set": [
    null,
    "9° set"
  ],
  "A server issue has interrupted media playback.": [
    null,
    "Si è verificato un errore di rete. Impossibile proseguire la lettura del video."
  ],
  "ALL-IN": [
    null,
    "ALL-IN"
  ],
  "Accept changes": [
    null,
    "Conferma le modifiche"
  ],
  "Acces to media failed.": [
    null,
    "Accesso al contenuto fallito."
  ],
  "Accumulator": [
    null,
    "Multipla"
  ],
  "Accumulator %1$s": [
    null,
    "Multipla %1$s"
  ],
  "Add": [
    null,
    "Aggiungi"
  ],
  "Add an In-Play selection to get a %1$s bonus": [
    null,
    "Aggiungi una scommessa live per ottenere un bonus di %1$s"
  ],
  "Add bet to basket": [
    null,
    "Aggiungi la scommessa nel cestino"
  ],
  "Add one selection to get a %1$s bonus": [
    null,
    "Aggiungi una scommessa per ottenere un bonus di %1$s"
  ],
  "Additional buttons allow you to make variations of an existing grid.": [
    null,
    "I pulsanti opzionali ti permettono di effettuare modifiche a una schedina già esistente."
  ],
  "Ajax Amsterdam": [
    null,
    "Ajax"
  ],
  "All": [
    null,
    "Tutte"
  ],
  "All my grids": [
    null,
    "Tutte le mie schedine"
  ],
  "All players": [
    null,
    "Tutti i giocatori"
  ],
  "All possible accumulators %1$s with %2$s from %3$s others, or %4$s in total": [
    null,
    "Tutte le multiple possibili %1$s con %2$s tra le altre %3$s, ovvero %4$s scommesse in totale"
  ],
  "All possible accumulators from the %1$s from amongst %2$s, or %3$s in total": [
    null,
    "Tutte le multiple possibili delle %1$s tra le %2$s, ovvero %3$s scommesse in totale"
  ],
  "All rules": [
    null,
    "Tutte le regole"
  ],
  "Amount": [
    null,
    "Importo"
  ],
  "Amount collected:": [
    null,
    "Somma raccolta:"
  ],
  "Amount shared out:": [
    null,
    "Importo ripartito:"
  ],
  "Amount to be carried forward:": [
    null,
    "Importo ancora in palio:"
  ],
  "An error as occurred.": [
    null,
    "Si è verificato un errore."
  ],
  "An error has occured": [
    null,
    "Si è verificato un errore."
  ],
  "An error occurred, please try again.": [
    null,
    "Si è verificato un errore, ti invitiamo a riprovare."
  ],
  "And remember,": [
    null,
    "E ricorda,"
  ],
  "And you will unlock phase 2.": [
    null,
    "E sbloccherai la fase 2."
  ],
  "And you will unlock phase 3.": [
    null,
    "E sbloccherai la fase 3."
  ],
  "Anytime": [
    null,
    "Marcatore"
  ],
  "Assistman": [
    null,
    "Assistman"
  ],
  "Assists": [
    null,
    "Assist"
  ],
  "Assists+rebounds": [
    null,
    "Assist+rimbalzi"
  ],
  "At least one of the two teams": [
    null,
    "Almeno una delle due squadre"
  ],
  "At least one of your multi-chance selections has too many choices.": [
    null,
    "Una o più delle tue scommesse multichance presentano troppi risultati."
  ],
  "At least one of your selections is currently suspended": [
    null,
    "Una o più delle tue scommesse sono attualmente sospese."
  ],
  "At least one of your selections is no longer available.": [
    null,
    "Una o più delle tue scommesse non sono più disponibili."
  ],
  "At least one of your selections is no longer available. Check your betslip.": [
    null,
    "Una o più delle tue scommesse non sono più disponibili. Verifica il carrello."
  ],
  "At least one of your selections is not eligible for MyMatch.": [
    null,
    "Una o più delle tue scommesse non sono selezionabili per la modalità MyMatch."
  ],
  "At least one of your selections is not eligible for MyMatch. Check your betslip.": [
    null,
    "Una o più delle tue scommesse non sono selezionabili per la modalità MyMatch. Verifica il carrello."
  ],
  "Atletico Madrid": [
    null,
    "Atletico Madrid"
  ],
  "Author": [
    null,
    "Autore"
  ],
  "BOOM, easy game!": [
    null,
    "BOOM, troppo facile!"
  ],
  "Back": [
    null,
    "Indietro"
  ],
  "Back to grid creation": [
    null,
    "Torna alla creazione della schedina"
  ],
  "Back to sports betting": [
    null,
    "Torna alle scommesse sportive"
  ],
  "Back to the grid of the day": [
    null,
    "Torna alla schedina del giorno"
  ],
  "Balance": [
    null,
    "Saldo"
  ],
  "Base": [
    null,
    "Base"
  ],
  "Bayern Munich": [
    null,
    "Bayern Monaco"
  ],
  "Best author (badge)": [
    null,
    "Migliore autore (badge)"
  ],
  "Best author (winnings)": [
    null,
    "Migliore autore (vincite)"
  ],
  "Best bets": [
    null,
    "Le migliori scommesse"
  ],
  "Bet": [
    null,
    "Scommessa"
  ],
  "Bet %1$s could not be redeemed, one or more selections are not eligible for Cashout": [
    null,
    "La scommessa %1$s non può essere riscattata perché una o più scommesse che la compongono non prevedono Cashout"
  ],
  "Bet %1$s could not be redeemed, remaining bet is less than €0.10": [
    null,
    "La scommessa %1$s non può essere riscattata perché la puntata rimanente è inferiore a 0,10€"
  ],
  "Bet %1$s could not be redeemed, the Cashout amount has changed": [
    null,
    "La scommessa %1$s non può essere riscattata perché l'importo del Cashout è cambiato"
  ],
  "Bet confirmation": [
    null,
    "Conferma"
  ],
  "Bet is limited to free bet": [
    null,
    "Scommessa disponibile solo con bonus scommesse"
  ],
  "Bet is not eligible for Boom %1$s": [
    null,
    "La scommessa non sarà contabilizzata per il Boom %1$s"
  ],
  "Bet is not eligible for Boom %1$s because at least one match starts after the end of the game": [
    null,
    "La scommessa non sarà contabilizzata per il Boom %1$s perché almeno una partita avrà inizio al termine del gioco"
  ],
  "Bet is not eligible for Boom %1$s because system bets are not eligible": [
    null,
    "La scommessa non sarà contabilizzata per il Boom %1$s perché i sistemi non sono presi in considerazione"
  ],
  "Bet is not eligible for Boom %1$s because the game is not in progress": [
    null,
    "La scommessa non sarà contabilizzata per il Boom %1$s perché il gioco non è in corso di svolgimento"
  ],
  "Bet is not eligible for Boom %1$s because the match starts in over 48 hours": [
    null,
    "La scommessa non sarà contabilizzata per il Boom %1$s perché la partita avrà inizio tra più di 48 ore"
  ],
  "Bet is not eligible for Boom %1$s because you have a bet in the validation process": [
    null,
    "La scommessa non sarà contabilizzata per il Boom %1$s perché hai un'altra scommessa in corso"
  ],
  "Bet is not eligible for Boom %1$s because you have already placed an eligible bet on the same match": [
    null,
    "La scommessa non sarà contabilizzata per il Boom %1$s perché hai già piazzato una scommessa sulla stessa partita"
  ],
  "Bet is not eligible for Boom %1$s because you have not started the game": [
    null,
    "La scommessa non sarà contabilizzata per il Boom %1$s perché non hai ancora avviato il gioco"
  ],
  "Bet is not eligible for Monopoly": [
    null,
    "La scommessa non è valida per il Monopoly"
  ],
  "Bet is not eligible for Monopoly because at least one match starts after the end of the game": [
    null,
    "La scommessa non è valida per il Monopoly perché almeno una partita avrà inizio al termine del gioco"
  ],
  "Bet is not eligible for Monopoly because system bets are not eligible": [
    null,
    "La scommessa non è valida per il Monopoly perché i sistemi non sono presi in considerazione"
  ],
  "Bet is not eligible for Monopoly because the game is not in progress": [
    null,
    "La scommessa non è valida per il Monopoly perché il gioco non è in corso di svolgimento."
  ],
  "Bet is not eligible for Monopoly because the match starts in over 48 hours": [
    null,
    "La scommessa non è valida per il Monopoly perché la partita avrà inizio tra più di 48 ore"
  ],
  "Bet is not eligible for Monopoly because you have already placed an eligible bet on the same match": [
    null,
    "La scommessa non è valida per il Monopoly perché hai già piazzato una scommessa sulla stessa partita"
  ],
  "Bet is not eligible for Monopoly because you have not started the game": [
    null,
    "La scommessa non è valida per il Monopoly perché non hai ancora avviato il gioco"
  ],
  "Bet is not eligible for the Gift Race": [
    null,
    "La scommessa non sarà contabilizzata per la Corsa al regalo"
  ],
  "Bet is not eligible for the Gift Race because at least one match starts after the end of the game": [
    null,
    "La scommessa non sarà contabilizzata per la Corsa al regalo perché almeno una parita comincerà dopo la fine del gioco"
  ],
  "Bet is not eligible for the Gift Race because system bets are not eligible": [
    null,
    "La scommessa non sarà contabilizzata per la Corsa al regalo perché il gioco non prende in considerazione i sistemi."
  ],
  "Bet is not eligible for the Gift Race because the game is not in progress": [
    null,
    "La scommessa non sarà contabilizzata per la Corsa al regalo perché il gioco non è in corso"
  ],
  "Bet is not eligible for the Gift Race because the match starts in over 48 hours": [
    null,
    "La scommessa non sarà contabilizzata per la Corsa al regalo perché la partita comincerà tra più di 48 ore"
  ],
  "Bet is not eligible for the Gift Race because this version of the game has ended": [
    null,
    "La scommessa non sarà contabilizzata per la Corsa al regalo perché questa versione del gioco è terminata."
  ],
  "Bet is not eligible for the Gift Race because you have a reward to collect in order to unlock the next gift": [
    null,
    "La scommessa non sarà contabilizzata per la Corsa al regalo perché devi prima ritirare la tua ricompensa per sbloccare il prossimo regalo"
  ],
  "Bet is not eligible for the Gift Race because you have already placed an eligible bet on the same match": [
    null,
    "La scommessa non sarà contabilizzata per la Corsa al regalo perché hai già piazzato una scommessa su questa partita"
  ],
  "Bet is not eligible for the Gift Race because you have already won the gift": [
    null,
    "La scommessa non sarà contabilizzata per la Corsa al regalo perché hai già vinto il regalo"
  ],
  "Bet is not eligible for the Gift Race because you have not started the game": [
    null,
    "La scommessa non sarà contabilizzata per la Corsa al regalo perché non hai avviato il gioco"
  ],
  "Bet is not eligible for the Gift Race because you must start the gift quest again": [
    null,
    "La scommessa non sarà contabilizzata per la Corsa al regalo perché non hai riavviato la tua partita"
  ],
  "Bet is not eligible for the Gift Race because your current bets will be decisive": [
    null,
    "La scommessa non sarà contabilizzata per la Corsa al regalo perché le tue scommesse in corso potrebbero essere decisive"
  ],
  "Bet modification unavailable": [
    null,
    "Modifica non disponibile"
  ],
  "Bet modification unavailable with free bets": [
    null,
    "Modifica non disponibile sui bonus scommesse"
  ],
  "Bet pending": [
    null,
    "Scommessa in attesa"
  ],
  "Bet refused": [
    null,
    "Scommessa rifiutata"
  ],
  "Bet stopped": [
    null,
    "Scommessa chiusa"
  ],
  "Bet suspended": [
    null,
    "Scommessa sospesa"
  ],
  "Bet tax free": [
    null,
    "Scommetti esentasse!"
  ],
  "Bet validated": [
    null,
    "Scommessa convalidata"
  ],
  "Bet validated!": [
    null,
    "Scommessa convalidata !"
  ],
  "Bet validation in progress": [
    null,
    "Scommessa in corso di convalida"
  ],
  "Bets on the competition": [
    null,
    "scommesse sulla competizione"
  ],
  "Betslip": [
    null,
    "Carrello"
  ],
  "Betting with Winamax": [
    null,
    "Scommettti online su Winamax"
  ],
  "Biggest accumulators": [
    null,
    "Migliori multiple"
  ],
  "Biggest winnings": [
    null,
    "Vincite più elevate"
  ],
  "Blocks": [
    null,
    "Stoppate"
  ],
  "Boom %1$s internal error": [
    null,
    "Boom %1$s: errore interno"
  ],
  "Boom St Valentine": [
    null,
    "Boom San Valentino"
  ],
  "Borussia M'Gladbach": [
    null,
    "Borussia M'Gladbach"
  ],
  "Both teams": [
    null,
    "Le due squadre"
  ],
  "Bracket": [
    null,
    "Tabellone"
  ],
  "Bravo!": [
    null,
    "Auguri!"
  ],
  "By ticking this box, your grid will be made private.": [
    null,
    "Selezionando questa casella scegli di rendere privata la tua schedina."
  ],
  "Cancelled": [
    null,
    "Annullate"
  ],
  "Cashout": [
    null,
    "Cashout"
  ],
  "Cashout (max %1$s)": [
    null,
    "Cashout (max %1$s)"
  ],
  "Cashout validated": [
    null,
    "Cashout convalidato"
  ],
  "Cashout validation in progress": [
    null,
    "Cashout in corso di validazione"
  ],
  "Cashout €%1$s": [
    null,
    "Cashout %1$s€"
  ],
  "Cashout: %2$s available": [
    "Cashout: %2$s available",
    "%2$s disponibile",
    "%2$s disponibili"
  ],
  "Certain data may not be up to date.": [
    null,
    "Alcuni dati potrebbero non essere aggiornati."
  ],
  "Check out the public grids as well as information about the authors of these grids and find the one that suits you best.": [
    null,
    "Controlla le schedine pubbliche e le informazioni sui loro autori e trova quella più adatta a te."
  ],
  "Check the full rules": [
    null,
    "Vedi il regolamento completo"
  ],
  "Choose the amount of your stake on this grid as a team.": [
    null,
    "Scegli l'importo in palio su questa schedina di gruppo."
  ],
  "Choose your format (7 or 12 matches) and validate your own grid.": [
    null,
    "Scegli il tuo formato (7 o 12 partite) e convalida la tua schedina."
  ],
  "Christmas is already over!": [
    null,
    "Natale è già finito!"
  ],
  "Claim": [
    null,
    "Ottieni"
  ],
  "Click and hold an image to save or share": [
    null,
    "Tieni premuto sull’immagine per salvarla o condividerla."
  ],
  "Close": [
    null,
    "Chiudi"
  ],
  "Close details": [
    null,
    "Chiudi dettagli"
  ],
  "Combinations": [
    null,
    "Multiple"
  ],
  "Combo booster": [
    null,
    "Combo booster"
  ],
  "Compact grid": [
    null,
    "Schedina compatta"
  ],
  "Compact view": [
    null,
    "Vista compatta"
  ],
  "Competitions": [
    null,
    "Competizioni"
  ],
  "Complete all 3 phases of the game by placing winning bets and walk away with legendary gifts and lots of Freebets:": [
    null,
    "Supera le 3 fasi di gioco vincendo le scommesse per ottenere regali leggendari e bonus scommesse:"
  ],
  "Complete bet": [
    null,
    "Completa la scommessa"
  ],
  "Confirm": [
    null,
    "Convalida"
  ],
  "Congratulations on your journey!": [
    null,
    "Congratulazioni per la tua vittoria!"
  ],
  "Congratulations!": [
    null,
    "Congratulazioni!"
  ],
  "Connection error.": [
    null,
    "Si è verificato un errore di connessione."
  ],
  "Contradictory selections": [
    null,
    "Scommesse contraddittorie"
  ],
  "Contradictory selections.": [
    null,
    "Le tue scommesse sono contraddittorie."
  ],
  "Contradictory selections. Check your betslip.": [
    null,
    "Le tue scommesse sono contraddittorie. Verifica il carrello."
  ],
  "Copied": [
    null,
    "Copiato"
  ],
  "Copy": [
    null,
    "Copia"
  ],
  "Copy the link": [
    null,
    "Copia il link"
  ],
  "Countries": [
    null,
    "Paesi"
  ],
  "Dead-Heat": [
    null,
    "Caso di pareggio"
  ],
  "Decisive": [
    null,
    "Decisivo"
  ],
  "Decisive players": [
    null,
    "Giocatori decisivi"
  ],
  "Delete grid": [
    null,
    "Cancella schedina"
  ],
  "Delete my favourites": [
    null,
    "Cancella tutti i preferiti"
  ],
  "Detailed grids": [
    null,
    "Schedina dettagliata"
  ],
  "Didn't understand everything on the previous screen?": [
    null,
    "Qualcosa ti è ancora poco chiara?"
  ],
  "Direct free kick": [
    null,
    "Punizione diretta"
  ],
  "Display sliders on relevant bets by default": [
    null,
    "Visualizza i cursori sulle scommesse come impostazione predefinita"
  ],
  "Do you like this application?": [
    null,
    "Ti piace questa app?"
  ],
  "Do you want to keep a low profile and only share your grid with your friends? Opt for the private grid.": [
    null,
    "Vuoi mantenere un profilo basso e condividere la tua schedina solamente con i tuoi amici? Scegli una schedina privata."
  ],
  "Do you wish to comment on this application?": [
    null,
    "Vorresti farci sapere cosa ne pensi e recensire l’app?"
  ],
  "Don't save bet": [
    null,
    "Non salvare più la scommessa"
  ],
  "Draw": [
    null,
    "Pareggio"
  ],
  "Duplicate grid": [
    null,
    "Duplica schedina"
  ],
  "Each simple bet is placed individually": [
    null,
    "Ogni scommessa singole è piazzata individualmente"
  ],
  "Edit": [
    null,
    "Modifica"
  ],
  "Enhance": [
    null,
    "Completa"
  ],
  "Error whilst crediting your reward": [
    null,
    "Errore durante la distribuzione della tua ricompensa"
  ],
  "Error, please try again": [
    null,
    "Errore, ti invitiamo a provare di nuovo"
  ],
  "Event abandoned": [
    null,
    "Evento abbandonato"
  ],
  "Event cancelled": [
    null,
    "Evento annullato"
  ],
  "Event ended": [
    null,
    "Evento terminato"
  ],
  "Event postponed": [
    null,
    "Evento posticipato"
  ],
  "Eventual winnings will be shared in proportion to each player's stake.": [
    null,
    "Eventuali vincite saranno ripartite in propozione alla puntata di ogni giocatore."
  ],
  "Excluding extra-time and penalty shoot-out.": [
    null,
    "Eccetto eventuali tempi supplementari e rigori."
  ],
  "Explode Cupid by winnings 5 bets": [
    null,
    "Fai esplodere Cupido vincendo 5 scommesse"
  ],
  "Explode the leprechaun by winnings 5 bets": [
    null,
    "Fai esplodere il folletto vincendo 5 scommesse"
  ],
  "Explode your pumpkin by winnings 5 bets": [
    null,
    "Fai esplodere la tua zucca vincendo 5 scommesse"
  ],
  "Extras": [
    null,
    "Promozioni"
  ],
  "FC Porto": [
    null,
    "Porto"
  ],
  "Filter bets": [
    null,
    "Filtra le scommesse"
  ],
  "Finance your entire grid or share the jackpot by playing as a team.": [
    null,
    "Finanzia interamente la tua schedina o condividi il montepremi giocando in gruppo."
  ],
  "Find out how much you've pocketed as soon as the last game of your grid ends.": [
    null,
    "Scopri quanto hai intascato non appena termina l'ultima partita della tua griglia."
  ],
  "First": [
    null,
    "Primo"
  ],
  "Flash": [
    null,
    "Flash"
  ],
  "Follow the live results and stats of your grids.": [
    null,
    "Segui i risultati e le statistiche delle tue schedine."
  ],
  "For a 24h break hold the button pressed for 3 seconds.": [
    null,
    "Tieni premuto il pulsante 3 secondi per una pausa di 24 ore."
  ],
  "Format change": [
    null,
    "Modifica del formato"
  ],
  "Frame %1$s": [
    null,
    "Frame %1$s"
  ],
  "Freebet Wager": [
    null,
    "Puntata bonus"
  ],
  "Freebet win for the complete colour collection: Reference bet x %1$s": [
    null,
    "Bonus scommesse associato alla collezione completata: puntata di riferimento x %1$s"
  ],
  "Freebet winnings if you win this level: Reference bet x %1$s": [
    null,
    "Ottieni bonus scommesse se vinci questo livello: Puntata di riferimento x %1$s"
  ],
  "Freebets Wager": [
    null,
    "Puntata bonus"
  ],
  "Game objective": [
    null,
    "Scopo del gioco"
  ],
  "Gather properties, complete colour collections and win lots of Freebets!": [
    null,
    "Ottieni le proprierà, completa le collezioni e vinci i bonus scommesse in palio!"
  ],
  "General problem": [
    null,
    "Problema generale."
  ],
  "Get started": [
    null,
    "Comincia"
  ],
  "Gift Race internal error": [
    null,
    "Errore intero de La corsa al regalo"
  ],
  "Goalscorer Duo": [
    null,
    "Duo Marcatore"
  ],
  "Goalscorer Guarantee": [
    null,
    "Garanzia marcatore"
  ],
  "Goalscorer Trio": [
    null,
    "Trio Marcatori"
  ],
  "Goalscorer in a period": [
    null,
    "Marcatore di un periodo"
  ],
  "Goalscorers in a 10 min period": [
    null,
    "Marcatori su un periodo di 10 min"
  ],
  "Goalscorers in a 15 min period": [
    null,
    "Marcatori su un periodo di 15 min"
  ],
  "Graphics preferences": [
    null,
    "Impostazioni grafica"
  ],
  "Grid": [
    null,
    "Schedina"
  ],
  "Grid %1$s winnings": [
    null,
    "Vincite schedina %1$s"
  ],
  "Grid price": [
    null,
    "Prezzo della schedina"
  ],
  "Grid result": [
    null,
    "Risultato della schedina"
  ],
  "Grids": [
    null,
    "Schedine"
  ],
  "Grids Home": [
    null,
    "Home schedine"
  ],
  "Guarantee:": [
    null,
    "Garanzia:"
  ],
  "Half time - Multiple goalscorers": [
    null,
    "Primo tempo – Marcatori multipli"
  ],
  "Half-time goalscorers": [
    null,
    "Marcatori in un tempo"
  ],
  "Halloween": [
    null,
    "Halloween"
  ],
  "Header": [
    null,
    "Colpo di testa"
  ],
  "Hidden": [
    null,
    "Nascoste"
  ],
  "Hide bet": [
    null,
    "Nascondi la scommessa"
  ],
  "Highest MyMatch odds": [
    null,
    "Quote MyMatch più alte"
  ],
  "Highest odds": [
    null,
    "Quote più alte"
  ],
  "Home": [
    null,
    "Home"
  ],
  "If you lose a bet, you start the phase from 0.": [
    null,
    "Se perdi una scommessa, ripartirai da 0 nella stessa fase."
  ],
  "Important account information": [
    null,
    "Informazioni relative al tuo conto"
  ],
  "In Play": [
    null,
    "Live"
  ],
  "In progress": [
    null,
    "In corso"
  ],
  "Incorrect PIN": [
    null,
    "Codice PIN errato"
  ],
  "Incorrect amount": [
    null,
    "Importo non valido"
  ],
  "Incorrect email, password or date of birth": [
    null,
    "Combinazione email/password errata"
  ],
  "Individual grid": [
    null,
    "Schedina individuale"
  ],
  "Inter Milan": [
    null,
    "Inter"
  ],
  "Internal error": [
    null,
    "Errore interno"
  ],
  "It's not the grids that matter, it's what you do with them!": [
    null,
    "L'importante non sono le schedine, ma quello che riesci a farne!"
  ],
  "It's simple! Select a result of your choice (team 1 or team 2 or draw) for each match.": [
    null,
    "È semplice! Seleziona un risultato per ogni partita (squadra 1, squadra 2 o pareggio)."
  ],
  "Koh-Lanta": [
    null,
    "Koh-Lanta"
  ],
  "Lacking inspiration? You can also take part in a public grid.": [
    null,
    "Mancanza di ispirazione? Partecipa a una schedina pubblica!"
  ],
  "Last": [
    null,
    "Ultimo"
  ],
  "Later": [
    null,
    "Più tardi"
  ],
  "Least expensive": [
    null,
    "Meno costose"
  ],
  "Less selections": [
    null,
    "Meno quote"
  ],
  "Level %1$s": [
    null,
    "Livello %1$s"
  ],
  "Line %1$s": [
    null,
    "Linea %1$s"
  ],
  "Link copied!": [
    null,
    "Link copiato!"
  ],
  "Live": [
    null,
    "Live"
  ],
  "Liverpool": [
    null,
    "Liverpool"
  ],
  "Loading": [
    null,
    "Caricamento"
  ],
  "Loading in progress": [
    null,
    "Caricamento in corso"
  ],
  "Log in": [
    null,
    "Accesso"
  ],
  "Log in to %1$s": [
    null,
    "Accedi a %1$s"
  ],
  "Lost": [
    null,
    "Perse"
  ],
  "Maintenance in progress": [
    null,
    "Manutenzione in corso"
  ],
  "Maintenance in progress.": [
    null,
    "Manutenzione in corso."
  ],
  "Manchester City": [
    null,
    "Manchester City"
  ],
  "Manchester United": [
    null,
    "Manchester United"
  ],
  "Map %1$s": [
    null,
    "Mappa %1$s"
  ],
  "Marseille": [
    null,
    "Marsiglia"
  ],
  "Match": [
    null,
    "Partita"
  ],
  "Match details": [
    null,
    "Dettagli della partita"
  ],
  "Match details and odds": [
    null,
    "Dettagli e quote della partita"
  ],
  "Match ended": [
    null,
    "Partita terminata"
  ],
  "Match odds": [
    null,
    "Le quote della partita"
  ],
  "Match result odds": [
    null,
    "Quote risultato partita"
  ],
  "Match unavailable": [
    null,
    "Partita indisponibile"
  ],
  "Matches": [
    null,
    "Partite"
  ],
  "Maximum selections reached": [
    null,
    "Numero massimo di scommesse raggiunto"
  ],
  "Min. odds": [
    null,
    "Quota min."
  ],
  "Min. odds:": [
    null,
    "Quota min.:"
  ],
  "Min. wager:": [
    null,
    "Puntata min.:"
  ],
  "Minimum odds to win this card: %1$s": [
    null,
    "Quota minima per ottenere questa carta: %1$s"
  ],
  "Minimum odds to win this level: %1$s": [
    null,
    "Quota minima per ottenere questo livello: %1$s"
  ],
  "Monopoly internal error": [
    null,
    "Errore interno del Monopoly "
  ],
  "More selections": [
    null,
    "Più quote"
  ],
  "Most advanced": [
    null,
    "Più avanzate"
  ],
  "Most expensive": [
    null,
    "Più costose"
  ],
  "Most popular": [
    null,
    "Più popolari"
  ],
  "Most recent": [
    null,
    "Più recenti"
  ],
  "Multiples:": [
    null,
    "Multiple:"
  ],
  "Multiscorers": [
    null,
    "Marcature multiple"
  ],
  "My bets": [
    null,
    "Le mie scommesse"
  ],
  "My collection": [
    null,
    "La mia collezizone"
  ],
  "My favourites": [
    null,
    "Preferiti"
  ],
  "My grids": [
    null,
    "Le mie schedine"
  ],
  "My wager": [
    null,
    "Le mie scommesse"
  ],
  "My winnings": [
    null,
    "Le mie vincite"
  ],
  "MyMatch currently unavailable": [
    null,
    "MyMatch attualmente indisponibile."
  ],
  "MyMatch mode": [
    null,
    "Modalità MyMatch"
  ],
  "MyMatch unavailable": [
    null,
    "MyMatch non disponibile"
  ],
  "News": [
    null,
    "News"
  ],
  "Next": [
    null,
    "Successiva"
  ],
  "Next grid": [
    null,
    "Prossima schedina"
  ],
  "Next grids": [
    null,
    "Prossime schedine"
  ],
  "No": [
    null,
    "No"
  ],
  "No bets": [
    null,
    "Nessuna scommessa"
  ],
  "No grid": [
    null,
    "Nessuna schedina"
  ],
  "No grid played": [
    null,
    "Nessuna schedina giocata"
  ],
  "No grids": [
    null,
    "Nessuna schedina"
  ],
  "No grids cancelled": [
    null,
    "Nessuna schedina cancellata"
  ],
  "No grids lost": [
    null,
    "Nessuna schedina persa"
  ],
  "No grids running": [
    null,
    "Nessuna schedina in corso"
  ],
  "No grids won": [
    null,
    "Nessuna schedina vinta"
  ],
  "No public grids": [
    null,
    "Nessuna schedina pubblica"
  ],
  "No rank 1 winners": [
    null,
    "Nessun vincitore al 1° livello"
  ],
  "No results": [
    null,
    "Nessun risultato"
  ],
  "No team": [
    null,
    "Nessuna squadra"
  ],
  "Non-top 10 competitor": [
    null,
    "Concorrente al di fuori della top 10"
  ],
  "Non-top 30 competitor": [
    null,
    "Concorrente al di fuori della top 30"
  ],
  "Not enough combinations": [
    null,
    "Numero di combinazioni insufficiente"
  ],
  "Notifications": [
    null,
    "Notifiche"
  ],
  "Number": [
    null,
    "Numero"
  ],
  "Number of bets": [
    null,
    "Numero di scommesse"
  ],
  "Number of goals from the player": [
    null,
    "Totale di gol del giocatore"
  ],
  "Odds": [
    null,
    "Quota"
  ],
  "Odds equal or inferior to 1": [
    null,
    "Quota uguale o inferiore a 1"
  ],
  "Odds:": [
    null,
    "Quota:"
  ],
  "Official lineups": [
    null,
    "Formazioni ufficiali"
  ],
  "Official starting lineups": [
    null,
    "Quintetto ufficiale"
  ],
  "Ok": [
    null,
    "Ok"
  ],
  "Olympiakos": [
    null,
    "Olympiakos"
  ],
  "One or multiple selections are unavailable": [
    null,
    "Una o più scommesse indisponibili"
  ],
  "Ongoing": [
    null,
    "In corso"
  ],
  "Oops,": [
    null,
    "Ops,"
  ],
  "Open the App Store": [
    null,
    "Apri l'App Store"
  ],
  "PRA": [
    null,
    "PRA"
  ],
  "Paris SG": [
    null,
    "Paris Saint-Germain"
  ],
  "Penalty": [
    null,
    "Rigore"
  ],
  "Penalty try": [
    null,
    "Meta tecnica"
  ],
  "Pending %1$s bets": [
    null,
    "Scommessa %1$s in attesa"
  ],
  "Pending bet refused": [
    null,
    "Scommessa in attesa rifiutata"
  ],
  "Pending bet validated": [
    null,
    "Scommessa in attesa convalidata"
  ],
  "Permanent and past promotions": [
    null,
    "Offerte fisse e offerte passate"
  ],
  "Phase 1: Pegasus Shoes": [
    null,
    "Fase 1: gli scarpini di Pegaso"
  ],
  "Phase 2: The remote control ball": [
    null,
    "Fase 2: il pallone telecomandato"
  ],
  "Phase 3: The Chameleon Jersey": [
    null,
    "Fase 3: la maglietta camaleonte"
  ],
  "Place a series of winning bets to score %1$s points.": [
    null,
    "Vinci le scommesse per ottenere %1$s punti."
  ],
  "Play the game to try and win a ton of Freebets!": [
    null,
    "Partecipa al gioco per tentare\ndi vincere il maggior numero di bonus scommesse!"
  ],
  "Player": [
    null,
    "Giocatore"
  ],
  "Player vs. player": [
    null,
    "Giocatore contro giocatore"
  ],
  "Player vs. team": [
    null,
    "Giocatore contro squadra"
  ],
  "Please enter a valid amount.": [
    null,
    "Ti preghiamo di inserire un importo valido."
  ],
  "Please enter your date of birth": [
    null,
    "La data di nascita è obbligatoria"
  ],
  "Points": [
    null,
    "Punti"
  ],
  "Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.": [
    null,
    "Tabella dei punti: 100 x il prodotto delle quote vincenti. Quindi, se le tue prime 3 scommesse risultano vincenti, vinci 100 x quota1 x quota2 x quota3 punti."
  ],
  "Points+assists": [
    null,
    "Punti+assist"
  ],
  "Points+rebounds": [
    null,
    "Punti+rimbalzi"
  ],
  "Poker": [
    null,
    "Poker"
  ],
  "Potential winnings": [
    null,
    "Vincita"
  ],
  "Previous": [
    null,
    "Precedente"
  ],
  "Prize distribution per player": [
    null,
    "Distribuzione premio per giocatore"
  ],
  "Prizepool": [
    null,
    "Montepremi"
  ],
  "Probable starting lineups": [
    null,
    "Probabile quintetto"
  ],
  "Prohibited": [
    null,
    "Vietato"
  ],
  "Prohibited (no-stakes game)": [
    null,
    "Vietato (partita senza posta in palio)"
  ],
  "Projected lineups": [
    null,
    "Probabili formazioni"
  ],
  "Provisional grid result": [
    null,
    "Risultato provvisorio schedina"
  ],
  "Provisional prize distribution": [
    null,
    "Distribuzione provvisoria vincite"
  ],
  "Public grid": [
    null,
    "Schedina pubblica"
  ],
  "Public grids": [
    null,
    "Schedine pubbliche"
  ],
  "Real Madrid": [
    null,
    "Real Madrid"
  ],
  "Rebounds": [
    null,
    "Rimbalzi"
  ],
  "Ref:": [
    null,
    "N:"
  ],
  "Reference": [
    null,
    "ID"
  ],
  "Reference bet: the smallest bet of the levels you have won (max %1$s)": [
    null,
    "Puntata di riferimento: la puntata minima dei livelli vinti (max. %1$s)"
  ],
  "Refuse": [
    null,
    "Rifiuta"
  ],
  "Refused": [
    null,
    "Rifiutate"
  ],
  "Repeat this bet": [
    null,
    "Riprendi questa scommessa"
  ],
  "Reset": [
    null,
    "Annulla"
  ],
  "Reset the grid": [
    null,
    "Resetta schedina"
  ],
  "Result": [
    null,
    "Risultato"
  ],
  "Retired or defaulted": [
    null,
    "Abbandono o squalifica"
  ],
  "Reviews": [
    null,
    "Revisioni"
  ],
  "Right-click an image to copy it or to save it on your device": [
    null,
    "Clicca col pulsante destro sull’immagine per copiarla o salvarla."
  ],
  "Rules": [
    null,
    "Regolamento"
  ],
  "Running": [
    null,
    "In corso"
  ],
  "Save bet": [
    null,
    "Salva la scommessa"
  ],
  "Save my selection": [
    "Save my selections",
    "Conserva la scommessa nel carrello",
    "Conserva le scommesse nel carrello"
  ],
  "Saved": [
    null,
    "Salvate"
  ],
  "Scan a bonus code": [
    null,
    "Scansiona un codice bonus"
  ],
  "Scorer": [
    null,
    "Marcatore"
  ],
  "Scorer type": [
    null,
    "Tipo di gol del giocatore"
  ],
  "Scorers": [
    null,
    "Marcatori"
  ],
  "Search": [
    null,
    "Cerca"
  ],
  "See all": [
    null,
    "Vedi tutto"
  ],
  "See all odds": [
    null,
    "Vedi tutte le quote"
  ],
  "See details": [
    null,
    "Dettagli"
  ],
  "See more selections": [
    null,
    "Visualizza più quote"
  ],
  "See top matches": [
    null,
    "Vedi i top match"
  ],
  "Select": [
    null,
    "Seleziona"
  ],
  "Service unavailable": [
    null,
    "Servizio non disponibile"
  ],
  "Settings": [
    null,
    "Impostazioni"
  ],
  "Shaktar Donetsk": [
    null,
    "Shaktar Donetsk"
  ],
  "Share bet to a friend's basket": [
    null,
    "Condividi la scommessa nel cestino di un amico"
  ],
  "Share image": [
    null,
    "Condividi l'immagine"
  ],
  "Share my bet": [
    null,
    "Condividi"
  ],
  "Share options": [
    null,
    "Opzioni di condivisione"
  ],
  "Shop": [
    null,
    "Negozio"
  ],
  "Show animation when adding a selection to betslip": [
    null,
    "Visualizza animazione all'aggiunta di una scommessa nel carrello"
  ],
  "Show bet": [
    null,
    "Non nascondere più la scommessa"
  ],
  "Show username": [
    null,
    "Mostra username"
  ],
  "Show wager and winnings": [
    null,
    "Mostra puntata e vincita"
  ],
  "Sign-in": [
    null,
    "Accedi"
  ],
  "Sign-in and place bet": [
    null,
    "Effettua l'accesso per scommettere"
  ],
  "Sign-up": [
    null,
    "Iscriviti"
  ],
  "Simple touchdown scorer": [
    null,
    "Marcatore"
  ],
  "Single": [
    null,
    "Singola"
  ],
  "Skip all": [
    null,
    "Salta tutto"
  ],
  "Sports": [
    null,
    "Sport"
  ],
  "Sports bets": [
    null,
    "Scommesse sportive"
  ],
  "St Patrick": [
    null,
    "St Patrick"
  ],
  "St Valentine": [
    null,
    "San Valentino"
  ],
  "Start": [
    null,
    "Inizia"
  ],
  "Start again": [
    null,
    "Ricomincia"
  ],
  "Starter": [
    null,
    "Titolare"
  ],
  "Starters": [
    null,
    "Titolari"
  ],
  "Starting 5 Guarantee": [
    null,
    "Garanzia basket"
  ],
  "Stats": [
    null,
    "Statistiche"
  ],
  "Steals": [
    null,
    "Palle rubate"
  ],
  "Steals+blocks": [
    null,
    "Palle rubate+stoppate"
  ],
  "Substitutes": [
    null,
    "Sostituti"
  ],
  "System": [
    null,
    "Sistema"
  ],
  "System %1$s": [
    null,
    "Sistema %1$s"
  ],
  "System %1$s/%2$s": [
    null,
    "Sistema %1$s/%2$s"
  ],
  "System bet": [
    null,
    "Sistema"
  ],
  "System grid": [
    null,
    "Sistemi schedina"
  ],
  "System grid price": [
    null,
    "Prezzo sistemi schedina"
  ],
  "Take part": [
    null,
    "Partecipa"
  ],
  "Team 1": [
    null,
    "Squadra 1"
  ],
  "Team 2": [
    null,
    "Squadra 2"
  ],
  "Team grid": [
    null,
    "Schedina di gruppo"
  ],
  "Terms and Conditions and Privacy Policy": [
    null,
    "Termini e condizioni e trattamento dei dati personali"
  ],
  "The Gift Race": [
    null,
    "La corsa al regalo"
  ],
  "The Pegasus shoes to fly over your next match": [
    null,
    "Gli scarpini di Pegaso per volare sul prato verde"
  ],
  "The bet is not eligible for Boom %1$s because Freebets are not taken into account": [
    null,
    "La scommessa non sarà contabilizzata per il Boom %1$s perché le puntate in bonus scommesse non sono prese in considerazione"
  ],
  "The bet is not eligible for Monopoly because Freebets are not taken into account": [
    null,
    "La scommessa non è valida per il Monopoly perché le puntate in bonus scommesse non sono prese in considerazione"
  ],
  "The chameleon jersey to change teams in a flash": [
    null,
    "La maglietta camaleonte per cambiare squadra in un attimo"
  ],
  "The classic accumulator wins if the %1$s are correct": [
    null,
    "La multipla classica, vincente se i %1$s sono corretti"
  ],
  "The date of birth entered does not match the date registered on your account": [
    null,
    "La data di nascita inserita non corrisponde a quella del conto"
  ],
  "The date of birth you have entered is invalid": [
    null,
    "La data di nascita inserita non è valida."
  ],
  "The game is over": [
    null,
    "Il gioco è terminato"
  ],
  "The game will end in under 24 hours": [
    null,
    "Questa promozione terminerà tra meno di 24 ore"
  ],
  "The maximum stake for this bet has already been reached, or the stake is lower than the minimum of €0.10": [
    null,
    "Hai raggiunto la puntata massima per questa scommessa o la tua puntata è inferiore alla puntata minima di 0,10€"
  ],
  "The maximum wager is %1$s": [
    null,
    "La puntata massima è %1$s"
  ],
  "The minimum odds are %1$s": [
    null,
    "La quota minima è %1$s"
  ],
  "The minimum wager is %1$s": [
    null,
    "La puntata minima è %1$s"
  ],
  "The odds have changed": [
    null,
    "La quota è cambiata"
  ],
  "The prize for this collection has already been claimed": [
    null,
    "Hai già ottenuto la ricompensa associata a questa collezione"
  ],
  "The remote-controlled ball with its unpredictable trajectories": [
    null,
    "Il pallone telecomandato e le sue traiettorie imprevedibili"
  ],
  "The service is currently unavailable. We will restore this as soon as possible. We apologise for any inconveniences caused by this.": [
    null,
    "Il servizio è attualmente indisponibile. Sarà ripristinato il più presto possibile. Ci scusiamo per il disagio."
  ],
  "The system grid is an expert mode. It allows you to create complex grids with some basic matches.": [
    null,
    "I sistemi schedina sono per esperti. Ti permettono di creare schedine complesse con partite base."
  ],
  "The video could not be loaded as it is an unsupported video format or due to a server issue.": [
    null,
    "Impossibile caricare il video. Formato non supportato o errore del server."
  ],
  "This QR code is not a Winamax bonus code": [
    null,
    "Questo QR code non è un codice bonus"
  ],
  "This broadcast is not available in your country of residence.": [
    null,
    "La diffusione di questo video non è autorizzata nel tuo paese."
  ],
  "This code is not a Winamax bonus code or has already been credited": [
    null,
    "Il codice non è un codice bonus Winamax o è già stato utilizzato"
  ],
  "This event is no longer available": [
    null,
    "L'evento non è più disponibile"
  ],
  "This free bet cannot be used": [
    null,
    "Impossibile utilizzare questo bonus scommesse"
  ],
  "This match is already included in the betslip you wish to enhance.": [
    null,
    "Questa partita è già presente nella scommessa che intendi completare."
  ],
  "This promotion has ended": [
    null,
    "Questa promozione è terminata"
  ],
  "This promotion will end in under 24 hours": [
    null,
    "Questa promozione terminerà tra meno di 24 ore"
  ],
  "This version of the software is not supported": [
    null,
    "Questa versione dell\"applicazione non è supportata"
  ],
  "This video could not be loaded as it has unsupported functionalities.": [
    null,
    "Impossibile caricare il video. Funzionalità non supportate."
  ],
  "Three-pointers": [
    null,
    "Triple"
  ],
  "Tick the boxes in your grid.": [
    null,
    "Spunta le caselle della schedina."
  ],
  "To be won": [
    null,
    "In palio"
  ],
  "Tomorrow": [
    null,
    "Domani"
  ],
  "Too many attempts.": [
    null,
    "Troppi tentativi."
  ],
  "Too many bankers": [
    null,
    "Troppe basi selezionate"
  ],
  "Too many bets selected": [
    null,
    "Troppe scommesse selezionate"
  ],
  "Too many selections": [
    null,
    "Troppe scommesse selezionate"
  ],
  "Top competitions": [
    null,
    "Migliori competizioni"
  ],
  "Total": [
    null,
    "Totale"
  ],
  "Total away": [
    null,
    "Totale in trasferta"
  ],
  "Total home": [
    null,
    "Totale in casa"
  ],
  "Total odds": [
    null,
    "Quote totali"
  ],
  "Total wager": [
    null,
    "Puntata totale"
  ],
  "Total winnings": [
    null,
    "Totale delle vincite"
  ],
  "Touchdowns scorers": [
    null,
    "Marcatori di touchdowns"
  ],
  "Try again": [
    null,
    "Riprova"
  ],
  "Try scorer Duo": [
    null,
    "Duo Marcatore di meta"
  ],
  "Try scorer Trio": [
    null,
    "Trio Marcatore di meta"
  ],
  "Try scorers": [
    null,
    "Marcatori di mete"
  ],
  "Try:": [
    null,
    "Prova:"
  ],
  "Turnovers": [
    null,
    "Palle perse"
  ],
  "Type of goal scored by a team": [
    null,
    "Tipo di gol di una squadra"
  ],
  "Unable to calculate odds": [
    null,
    "Impossibile calcolare la quota"
  ],
  "Upcoming matches": [
    null,
    "Prossimi eventi (calendario)"
  ],
  "Update": [
    null,
    "Aggiorna"
  ],
  "Use Freebets": [
    null,
    "Usa un bonus scommesse"
  ],
  "Use a bonus": [
    null,
    "Usa un bonus"
  ],
  "Video unavailable": [
    null,
    "Video non disponibile."
  ],
  "View my bet": [
    null,
    "Vedi le scommesse"
  ],
  "View the most wagered bets in the last %1$s mins": [
    null,
    "Scopri le scommesse più popolari degli ultimi %1$s min"
  ],
  "View the most wagered bets in the last hour": [
    null,
    "Scopri le scommesse più popolari dell'ultima ora"
  ],
  "Wager": [
    null,
    "Puntata"
  ],
  "Wager:": [
    null,
    "Puntata:"
  ],
  "Walkover": [
    null,
    "Walkover"
  ],
  "Want another accumulator? Switch to MyMatch!": [
    null,
    "Vuoi un’altra combinazione? Vai in modalità MyMatch!"
  ],
  "Want another multi-chance accumulator? Switch to MyMatch!": [
    null,
    "Vuoi un’altra combinazione multichance? Vai in modalità MyMatch!"
  ],
  "Want to check out all the promotions Winamax has to offer?": [
    null,
    "Vuoi conoscere tutte le offerte di Winamax?"
  ],
  "Warning:": [
    null,
    "Attenzione:"
  ],
  "We were unable to generate your final image": [
    null,
    "Non abbiamo potuto creare la tua immagine."
  ],
  "We'll explain everything step by step!": [
    null,
    "Ti spiegheremo tutto passo dopo passo!"
  ],
  "Welcome to the grid tutorial": [
    null,
    "Benvenuto nella guida alle schedine"
  ],
  "Win a ton of Freebets along the way!": [
    null,
    "Ottieni il massimo di bonus scommesse!"
  ],
  "Win all previous levels in order to unlock this level": [
    null,
    "Per sbloccare questo livello devi vincere i livelli precedenti"
  ],
  "Win up to": [
    null,
    "Vinci fino a"
  ],
  "Win up to %1$s times your reference bet in Freebets!": [
    null,
    "Vinci fino a %1$s il valore della tua puntata in bonus scommesse!"
  ],
  "WinaTV channel": [
    null,
    "WinaTV channel"
  ],
  "Winamax QR code": [
    null,
    "QR code Winamax"
  ],
  "Winamax grid": [
    null,
    "Schedina Winamax"
  ],
  "Winning is everything": [
    null,
    "Il più importante é vincere"
  ],
  "Winnings": [
    null,
    "Vincite"
  ],
  "Winnings %1$s": [
    null,
    "Vincite %1$s"
  ],
  "Winnings inferior or equal to the wager": [
    null,
    "Vincita inferiore o uguale alla puntata"
  ],
  "Won": [
    null,
    "Vinte"
  ],
  "Xmas": [
    null,
    "Xmas"
  ],
  "Yes": [
    null,
    "Sì"
  ],
  "You aborted the media playback.": [
    null,
    "Lettura del video interrotta."
  ],
  "You are currently excluded from Monopoly due to your game limits": [
    null,
    "Sei attualmente escluso dal Monopoly a causa dei tuoi limiti di gioco"
  ],
  "You are currently excluded from betting promotions in your %1$s": [
    null,
    "Sei attualmente escluso dalle offerte scommesse sportive nei tuoi %1$s."
  ],
  "You are currently excluded from the Gift Race due to your game limits": [
    null,
    "Sei attualmente escluso da La corsa al regalo a causa dei tuoi limiti di gioco"
  ],
  "You are currently ineligible for Boom %1$s": [
    null,
    "Al momento non puoi partecipare al Boom %1$s"
  ],
  "You are currently ineligible for Monopoly": [
    null,
    "Non puoi partecipare al Monopoly"
  ],
  "You are currently ineligible for the Gift Race": [
    null,
    "Non puoi partecipare alla Corsa al regalo attualmente."
  ],
  "You are currently not eligible to betting promotions": [
    null,
    "Al momento non puoi approfittare delle offerte scommesse sportive."
  ],
  "You are not authorized to connect from this country.": [
    null,
    "Non sei autorizzato ad accedere da questo paese."
  ],
  "You can also make doubles or triples to increase your chances of winning": [
    null,
    "Puoi selezionare doppie e triple per aumentare le tue chance di vittoria."
  ],
  "You can also select doubles and triples to have a better chance of winning.": [
    null,
    "Puoi selezionare doppie e triple per aumentare le tue chance di vittoria."
  ],
  "You can do so right here! :index_vers_le_bas:": [
    null,
    "C'è una pagina dove ti spieghiamo tutto, clicca qui!"
  ],
  "You can select doubles and triples to increase your chances of winning.": [
    null,
    "Puoi selezionare doppie e triple per aumentare le tue chance di vittoria."
  ],
  "You cannot bet on this grid anymore": [
    null,
    "Non puoi più scommettere su questa schedina"
  ],
  "You cannot combine multiple bets on the same match": [
    null,
    "Non puoi combinare altre scommesse sulla stessa partita"
  ],
  "You cannot combine these bets": [
    null,
    "Non puoi combinare queste scommesse"
  ],
  "You have already placed the same bet recently": [
    null,
    "Hai già piazzato questa scommessa"
  ],
  "You have already received your reward": [
    null,
    "Hai già ricevuto la tua ricompensa"
  ],
  "You have been active for %1$s minutes now.": [
    null,
    "tai giocando da %1$s minuti."
  ],
  "You have exceeded the maximum stake for this bet": [
    null,
    "Se ha superado la cantidad máxima para esta apuesta"
  ],
  "You have made a request to change your password. Please check your emails.": [
    null,
    "Hai chiesto di cambiare password. Controlla le tue email."
  ],
  "You have no favourites": [
    null,
    "Non hai preferiti"
  ],
  "You have no funds in your account.": [
    null,
    "Non hai fondi nel tuo conto "
  ],
  "You lose": [
    null,
    "Hai perso"
  ],
  "You may not receive a booster on this bet": [
    null,
    "Non puoi ricevere il booster su questa scommessa"
  ],
  "You must be logged": [
    null,
    "Devi aver effettuato l'accesso"
  ],
  "You must be logged in to see this page": [
    null,
    "Devi aver effettuato l'accesso per visualizzare questa pagina"
  ],
  "You must be logged in to validate your bets": [
    null,
    "Devi aver effettuato l'accesso per convalidare le tue scommesse"
  ],
  "You must be logged in to validate your grid.": [
    null,
    "Devi effettuare l'accesso per convalidare la tua schedina."
  ],
  "You must be of majority age to play": [
    null,
    "Devi essere maggiorenne per accedere"
  ],
  "You must have a minimum of €1 on your account, or you must have placed a bet on this match.": [
    null,
    "Devi avere almeno 1€ sul tuo conto o aver scommesso su questa partita."
  ],
  "You must log in to %1$s in order to access your account.": [
    null,
    "Devi effettuare l'accesso a %1$s per visualizzare il tuo conto."
  ],
  "You must select doubles or triples to make a team grid.": [
    null,
    "Devi selezionare delle doppie o delle triple per creare una schedina di gruppo."
  ],
  "You must tick at least one box per line.": [
    null,
    "Devi selezionare almeno una casella per linea."
  ],
  "You must wager your deposit in order to withdraw it": [
    null,
    "Deberás jugar tu depósito para poder retirarlo"
  ],
  "You only have %1$s": [
    null,
    "Disponi solamente di %1$s"
  ],
  "You only have %1$s in Freebets available": [
    null,
    "Hai solo %1$s di bonus scommesse disponibili"
  ],
  "You will earn between %1$s and %2$s times your reference bet in Freebets.": [
    null,
    "Vincerai tra %1$s e %2$s volte il valore della tua puntata in bonus scommesse."
  ],
  "You will exceed your daily limit. The maximum wager is %1$s": [
    null,
    "In questo modo supererai il tuo limite giornaliero. La puntata massima è %1$s"
  ],
  "You will exceed your monthly limit. The maximum wager is %1$s": [
    null,
    "In questo modo supererai il tuo limite mensile. La puntata massima è %1$s"
  ],
  "You will exceed your weekly limit. The maximum wager is %1$s": [
    null,
    "In questo modo supererai il tuo limite settimanale. La puntata massima è %1$s"
  ],
  "You win": [
    null,
    "Ottenuta"
  ],
  "You win Freebets": [
    null,
    "Hai vinto un bonus scommesse"
  ],
  "You won Freebets": [
    null,
    "Hai vinto un bonus scommesse di"
  ],
  "You've already won everything!": [
    null,
    "Hai già vinto tutto!"
  ],
  "Your %1$s bet could not be cashed out": [
    null,
    "Non è stato possibile effettuare il cashout sulla scommessa %1$s"
  ],
  "Your %1$s bet has been validated": [
    null,
    "La tua scommessa di %1$s è stata convalidata"
  ],
  "Your %1$s bet was cashed out for %2$s": [
    null,
    "Hai effettuato un cashout di %2$s sulla scommessa %1$s"
  ],
  "Your account is frozen.": [
    null,
    "Il tuo conto è bloccato."
  ],
  "Your account is locked": [
    null,
    "Il tuo conto è bloccato"
  ],
  "Your account is not authorized for use in this region": [
    null,
    "Il tuo conto non è autorizzato ad accedere a questa piattaforma"
  ],
  "Your app is out of date, please update to the latest version": [
    null,
    "La versione della tua applicazione è obsoleta, ti invitiamo ad aggiornarla"
  ],
  "Your betslip is empty!": [
    null,
    "Il tuo carrello è vuoto"
  ],
  "Your bonus code has been accepted": [
    null,
    "Il tuo codice bonus è stato registrato"
  ],
  "Your email address has not been verified. Please check your emails.": [
    null,
    "Il tuo conto non è stato convalidato. Controlla le tue email."
  ],
  "Your grid has %1$s double": [
    "Your grid has %1$s doubles",
    "La tua schedina ha %1$s doppia",
    "La tua schedina ha %1$s doppie"
  ],
  "Your grid has been validated.": [
    null,
    "La tua schedina è stata convalidata."
  ],
  "Your grid will only be validated once it has been entirely financed.": [
    null,
    "La tua griglia sarà convalidata quando sarà stata interamente finanziata."
  ],
  "Your mission is simple:": [
    null,
    "La tua missione è semplice:"
  ],
  "Your participation in the game has already been validated": [
    null,
    "La tua partecipazione al gioco è già stata confermata"
  ],
  "Your turn to play!": [
    null,
    "Ora tocca a te!"
  ],
  "Your winnings of %1$s will be credited to you as soon as all bets are settled.": [
    null,
    "La tua vincita di %1€s ti sarà accreditata non appena saranno definiti tutti i risultati delle scommesse."
  ],
  "abandoned": [
    null,
    "abbandono"
  ],
  "already received": [
    null,
    "già ricevuti"
  ],
  "and %1$s triple": [
    "and %1$s triples",
    "e %1$s tripla",
    "e %1$s triple"
  ],
  "break": [
    null,
    "intervallo"
  ],
  "collected": [
    null,
    "raccolti"
  ],
  "delayed": [
    null,
    "posticipata"
  ],
  "events in progress": [
    null,
    "eventi in corso"
  ],
  "extra innings": [
    null,
    "extrainning"
  ],
  "extra-time": [
    null,
    "tempi supplementari"
  ],
  "extra-time - 1st half": [
    null,
    "tempi supplementari - 1° tempo"
  ],
  "extra-time - 2nd half": [
    null,
    "tempi supplementari - 2° tempo"
  ],
  "extra-time finished": [
    null,
    "tempi supplementari terminati"
  ],
  "extra-time half-time": [
    null,
    "intervallo tempi supplementari"
  ],
  "extra-time will begin": [
    null,
    "iniziano i tempi suppplementari"
  ],
  "free": [
    null,
    "gratis"
  ],
  "gaming limits": [
    null,
    "limiti di gioco"
  ],
  "golden set": [
    null,
    "golden set"
  ],
  "grid %1$s n°%2$s": [
    null,
    "schedina %1$s n: %2$s"
  ],
  "grids": [
    null,
    "schedine"
  ],
  "guaranteed": [
    null,
    "garantiti"
  ],
  "half-time": [
    null,
    "intervallo"
  ],
  "handicap format": [
    null,
    "formato handicap"
  ],
  "how it works": [
    null,
    "come funziona"
  ],
  "in progress": [
    null,
    "in corso"
  ],
  "including %1$s:": [
    null,
    "con %1$s:"
  ],
  "including rank 1 deferral:": [
    null,
    "includendo posticipo primo livello:"
  ],
  "match abandoned": [
    null,
    "partita abbandonata"
  ],
  "match delayed": [
    null,
    "partita posticipata"
  ],
  "match finished": [
    null,
    "terminata"
  ],
  "match in progress": [
    null,
    "partita in corso"
  ],
  "match interrupted": [
    null,
    "partita sospesa"
  ],
  "match interuppted": [
    null,
    "partita sospesa"
  ],
  "match postponed": [
    null,
    "partita rinviata"
  ],
  "match started": [
    null,
    "partita iniziata"
  ],
  "missions:AlreadyOpted": [
    null,
    "Iscrizione effettuata"
  ],
  "missions:Log in": [
    null,
    "Accedi"
  ],
  "missions:Opt in": [
    null,
    "Partecipa"
  ],
  "most popular": [
    null,
    "più giocati"
  ],
  "no events": [
    null,
    "nessun evento"
  ],
  "n°": [
    null,
    "n:"
  ],
  "of the base": [
    "of %1$s bases",
    "della base",
    "delle %1$s basi"
  ],
  "ok": [
    null,
    "ok"
  ],
  "or": [
    null,
    "o"
  ],
  "overtime": [
    null,
    "tempi supplementari"
  ],
  "overtime finished": [
    null,
    "tempi supplementari terminati"
  ],
  "overtime will begin": [
    null,
    "iniziano i tempi supplementari"
  ],
  "own goal": [
    null,
    "autogol"
  ],
  "pause": [
    null,
    "in pausa"
  ],
  "penalty": [
    null,
    "rigore"
  ],
  "penalty shoot-out": [
    null,
    "calci di rigore"
  ],
  "retired": [
    null,
    "ritirato"
  ],
  "selection": [
    "selections",
    "scommessa",
    "scommesse"
  ],
  "session break": [
    null,
    "intervallo"
  ],
  "sudden death": [
    null,
    "golden meta"
  ],
  "text format": [
    null,
    "formato testo"
  ],
  "the 2nd quarter will begin": [
    null,
    "inizia il 2° quarto"
  ],
  "the 2nd set will begin": [
    null,
    "inizia il 2° set"
  ],
  "the 3rd quarter will begin": [
    null,
    "inizia il 3° tempo"
  ],
  "the 3rd set will begin": [
    null,
    "inizia il 3° set"
  ],
  "the 4th quarter will begin": [
    null,
    "inizia il 4° quarto"
  ],
  "the 4th set will begin": [
    null,
    "inizia il 4° set"
  ],
  "the 5th set will begin": [
    null,
    "inizia il 5° set"
  ],
  "timer:d": [
    null,
    "d"
  ],
  "timer:finished": [
    null,
    "Terminato"
  ],
  "timer:h": [
    null,
    "h"
  ],
  "timer:min": [
    null,
    "min"
  ],
  "up to": [
    null,
    "fino a"
  ],
  "walkover": [
    null,
    "walkover"
  ],
  "with your next deposit": [
    null,
    "con il tuo prossimo deposito"
  ]
}
  }
}
